import { AxiosHttpClient, ErrorHandlingUtils, Logger, NOOP, UserNotificationUtils } from '../utils';
export default class BaseManager {
    static getClassName() {
        return this.name;
    }
    static async get(url) {
        const logTag = this.getClassName();
        Logger.info(logTag, `Loading data from ${url}...`);
        let response;
        try {
            response = await (new AxiosHttpClient()).get(url, NOOP, NOOP, undefined, undefined);
            if (response?.successMessage) {
                UserNotificationUtils.showSuccess(response.successMessage);
            }
            if (response['data'] === undefined) {
                throw new Error('No data returned from the server.');
            }
        }
        catch (error) {
            if (url === '/o/v1/notifications') {
                throw error;
            }
            if (error?.id === ErrorHandlingUtils.ERROR_CODE_INVALID_PARAMETER) {
                if (error?.parameters?.description) {
                    UserNotificationUtils.showError(error?.parameters?.description);
                }
            }
            throw error;
        }
        return response.data;
    }
    static async post(url, data) {
        const logTag = this.getClassName();
        Logger.info(logTag, `Saving data to ${url}...`);
        let response;
        try {
            response = await (new AxiosHttpClient()).post(url, data, NOOP, NOOP, undefined);
            if (response?.successMessage) {
                UserNotificationUtils.showSuccess(response.successMessage);
            }
            if (response['data'] === undefined) {
                throw new Error('No data returned from the server.');
            }
        }
        catch (error) {
            if (error?.id === ErrorHandlingUtils.ERROR_CODE_INVALID_PARAMETER) {
                if (error?.parameters?.description) {
                    UserNotificationUtils.showError(error?.parameters?.description);
                }
            }
            else {
                throw error;
            }
        }
        return response.data;
    }
    static async delete(url) {
        const logTag = this.getClassName();
        Logger.info(logTag, `Deleting ${url}...`);
        let response;
        try {
            response = await (new AxiosHttpClient()).delete(url);
            if (response?.successMessage) {
                UserNotificationUtils.showSuccess(response.successMessage);
            }
        }
        catch (error) {
            if (error?.id === ErrorHandlingUtils.ERROR_CODE_INVALID_PARAMETER) {
                if (error?.parameters?.description) {
                    UserNotificationUtils.showError(error?.parameters?.description);
                }
            }
            else {
                throw error;
            }
        }
        return response.data;
    }
}
//# sourceMappingURL=BaseManager.js.map